export const FeaturesList = {
    SpaceCreationUsingTemplates: 'space_creation_using_templates',
    SearchPageTagFilter: 'search_page_tag_filter',
    PostTypes: 'post_types',
    ViewPostOnVisible: 'view_post_on_visible',
    TotalsAnalytics: 'totals_analytics',
    CommandBar: 'command_bar',
    CreateSpaceTemplate: 'create_space_template',
    TranslateButton: 'translate_button',
};
//# sourceMappingURL=features.js.map